export default "__VITE_ASSET__BkenZbZN__"